<template>
    <div id="suspended-frame">
        <div class="container is-max-desktop">
            <div class="suspension-alert">
                <h1 class="logo"><strong>my</strong>247ed.com</h1>
                <div class="alert-inner">
                    <div class="alert-content">
                        <div class="alert-icon">
                            <i class="fas fa-ban"></i>
                        </div>
                        <div class="alert-body">
                            <h2><strong>Account Suspended</strong></h2>
                            <p class="suspension-message">{{ currentUser.suspension_message }}</p>
                            <p>If you believe this is an error or have questions, please contact us at <a href="mailto:support@my247ed.com">support@my247ed.com</a>.</p>
                            <div class="alert-actions">
                                <router-link to="/signout" class="btn-primary">
                                    <i class="fas fa-sign-out mr-2"></i>Logout
                                </router-link>
                                <a href="mailto:support@my247ed.com?subject=Account Suspension Question" class="btn-secondary">
                                    <i class="fas fa-envelope mr-2"></i>Contact Support
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: 'suspended',
        computed: {
            ...mapGetters(['currentUser']),
        },
        mounted() {
            if (!this.currentUser || !this.currentUser.suspension_message) {
                this.$router.push('/dashboard');
            }
        }
    };
</script>

<style lang="scss">
    #suspended-frame {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        align-items: center;
        justify-content: center;
        background: #224C74 radial-gradient(#336699, #1e385c);
        padding: 2rem;

        .suspension-alert {
            background-color: white;
            border-radius: 0.5rem;
            padding: 1.5rem 1.5rem 1rem;
            box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.4);
            margin-top: 4rem;

            .logo {
                color: #282828;
                font-weight: normal;
                font-size: 2.2rem;
                margin-bottom: 1.5rem;
                letter-spacing: -1px;

                strong {
                    color: #336699;
                    font-weight: 900;
                }

                @media (max-width: 768px) {
                    font-size: 1.8rem;
                    margin-bottom: 1rem;
                }
            }

            .alert-inner {
                border: 2px solid #dc3545;
                border-radius: 0.375rem;
                padding: 1.5rem;
            }

            .alert-content {
                display: flex;
                align-items: flex-start;
                gap: 1.25rem;

                .alert-icon {
                    font-size: 2rem;
                    color: #dc3545;
                    flex-shrink: 0;
                    margin-top: -0.5rem;
                }

                .alert-body {
                    flex: 1;

                    h2 {
                        font-size: 1.15rem;
                        color: #333;
                        margin-bottom: 0.5rem;
                        font-weight: 600;

                        strong {
                            color: #dc3545;
                        }
                    }

                    p {
                        color: #555;
                        font-size: 0.95rem;
                        line-height: 1.5;
                        margin-bottom: 1.25rem;

                        &.suspension-message {
                            color: #333;
                            font-weight: 600;
                            font-size: 1rem;
                        }

                        a {
                            color: #dc3545;
                            text-decoration: underline;
                        }
                    }

                    .alert-actions {
                        display: flex;
                        gap: 0.75rem;
                        flex-wrap: wrap;

                        a {
                            text-decoration: none;
                            padding: 0.65rem 1.25rem;
                            border-radius: 0.375rem;
                            font-weight: 500;
                            transition: all 0.15s ease;
                            display: inline-flex;
                            align-items: center;
                            font-size: 0.9rem;

                            &.btn-primary {
                                background: #dc3545;
                                color: #fff;

                                &:hover {
                                    background: #c82333;
                                    transform: translateY(-1px);
                                }
                            }

                            &.btn-secondary {
                                background: transparent;
                                color: #666;
                                border: 1px solid #ccc;
                                font-size: 0.85rem;

                                &:hover {
                                    background: #f5f5f5;
                                    color: #333;
                                    border-color: #999;
                                }
                            }
                        }
                    }
                }
            }

            @media (max-width: 768px) {
                padding: 0.375rem;

                .alert-inner {
                    padding: 1.25rem;
                }

                .alert-content {
                    gap: 1rem;

                    .alert-icon {
                        font-size: 1.5rem;
                    }

                    .alert-body {
                        h2 {
                            font-size: 1.05rem;
                        }

                        p {
                            font-size: 0.9rem;
                        }

                        .alert-actions {
                            flex-direction: column;
                            gap: 0.5rem;

                            a {
                                width: 100%;
                                justify-content: center;
                            }
                        }
                    }
                }
            }
        }

        @media (max-width: 768px) {
            padding: 1rem;
            align-items: flex-start;
            padding-top: 3rem;
        }
    }
</style>
